import SanityImageField from "@/integrations/sanity/components/SanityImageField"
import PlaceableBlock from "@/ui/structure/PlaceableBlock"
import { classNames, ResponsiveStringValue } from "@punks/ui-core"

export interface SanityDecorationProps {
  asset: any
  position: ResponsiveStringValue
  objectPosition?: ResponsiveStringValue
  size: ResponsiveStringValue
  className?: string
  absolute?: boolean
}

export const SanityDecoration = ({
  asset,
  position,
  objectPosition,
  size,
  className,
  absolute,
}: SanityDecorationProps) => {
  return (
    <PlaceableBlock
      position={position}
      size={size}
      objectPosition={objectPosition}
      className={classNames(
        {
          "h-full absolute": absolute,
        },
        className
      )}
    >
      <SanityImageField
        asset={asset}
        responsive
        objectFit="contain"
        height="100%"
      />
    </PlaceableBlock>
  )
}
